import { isFalsy } from 'utility-types';
import { getPosts } from '@/api/appstore.api';
import type { ListPageModel, PageModel } from '@/interfaces/service/api.interface';
import type { AppStore, AppStorePostFilter, ChannelId, Post, PostsDto } from '@/interfaces/service/appstore/appstore.interface';
import { POST_PAGGE_SIZE } from '@/constants/appstore/post.constants';
import { getToken } from '@/utils/auth.util';

export const setRequestPostParams = (AppStore: AppStore, pageData?: PageModel): PostsDto => {
  const { storeId, channels, filter, sortOption } = AppStore;

  pageData = pageData ?? { pageNo: 1, pageSize: POST_PAGGE_SIZE };

  const newFilter: Partial<AppStorePostFilter> = {};
  Object.keys(filter ?? {})?.forEach((key) => {
    const value = filter[key];

    const nullableArrayProps = ['violationList', 'positiveWordList', 'negativeWordList', 'productPostStatus'];
    if (key !== 'channelFilter') {
      if ((nullableArrayProps.includes(key) && value && value.length > 0) || !nullableArrayProps.includes(key)) {
        newFilter[key] = value;
      }
    }
  });

  const selectedChannelId: ChannelId | 'ALL' = filter?.channelFilter ?? 'ALL';
  let selectedChannels: ChannelId[] = channels.map((channel) => channel.channelId);

  if (selectedChannelId !== 'ALL') {
    const selectedChannel = channels.find((channel) => channel.channelId === selectedChannelId);
    if (selectedChannel) {
      selectedChannels = [selectedChannel.channelId as ChannelId];
    } else {
      selectedChannels = [selectedChannelId];
    }
  }

  const params: PostsDto = {
    ...pageData,
    ...newFilter,
    storeId,
    channelIdList: selectedChannels,
    sortOption: sortOption ?? 'LATEST',
    includeTotalCount: pageData.pageNo === 1
  };

  if (isFalsy(params.replyFilter)) {
    params.replyFilter = 'ALL';
  }

  const token = getToken();
  if (isFalsy(token)) {
    delete params.productPostStatus;
  }

  return params;
};

export const getPostsWithFilter = async ({
  currentAppStore,
  pageData,
  teamId
}: {
  currentAppStore: AppStore;
  pageData: PageModel;
  teamId?: string;
}): Promise<{
  data: Post[];
  sliceValue?: ListPageModel;
  totalCount: number | null;
} | void> => {
  const params = setRequestPostParams(currentAppStore, pageData);

  const results = await getPosts(params, teamId);

  return results;
};

export const getMainReview = (reviews: AppStore[]) => reviews[0];
